// reportMapper.js

export const mapAIReport = (raw, company) => {
  if (!raw) return null;

  // 🔥 HANDLE BOTH CASES
  const data = raw.report ? raw.report : raw;

  const safeNumber = (val, fallback = 0) => {
    const num = Number(val);
    return isNaN(num) ? fallback : num;
  };

  const safeArray = (arr) => (Array.isArray(arr) ? arr : []);

  return {
    // -------------------------
    // HEADER
    // -------------------------
    company: {
      name: company?.companyName || "N/A",
      contact: company?.name || "N/A",
      email: company?.email || "N/A"
    },

    // -------------------------
    // SCORE SECTION
    // -------------------------
    score: safeNumber(data.score),

    score_breakdown: {
      data_maturity: safeNumber(data?.score_breakdown?.data_maturity),
      automation: safeNumber(data?.score_breakdown?.automation),
      ai_readiness: safeNumber(data?.score_breakdown?.ai_readiness)
    },

    industry_benchmark: {
      industry_avg_score: safeNumber(data?.industry_benchmark?.industry_avg_score),
      position: data?.industry_benchmark?.position || "Lagging"
    },

    maturity_level: data?.maturity_level || "Initial",

    cost_reduction_percent: safeNumber(data?.cost_reduction_percent),
    revenue_uplift_percent: safeNumber(data?.revenue_uplift_percent),
    roi: safeNumber(data?.roi),

    // -------------------------
    // OPPORTUNITIES (FIXED)
    // -------------------------
    opportunities: safeArray(data.opportunities).map((item, i) => {
      const text = String(item || "");

      return {
        id: i + 1,
        title:
          text.length > 80
            ? text.slice(0, 80) + "..."
            : text, // 🔥 clean title
        description: text
      };
    }),

    // -------------------------
    // ROADMAP
    // -------------------------
    roadmap: Array.isArray(data.roadmap)
      ? data.roadmap.map((phase, i) => ({
        id: i + 1,
        phase: phase?.phase || `Phase ${i + 1}`,
        action: phase?.action || ""
      }))
      : [],

    // -------------------------
    // SUMMARY
    // -------------------------
    summary: data?.summary || "No summary available"
  };
};